import { useEffect, useRef } from "react";
import { useI18n } from "../../i18n";
import { http } from "../../lib/api";

const toastLib = () => import("sonner").then((m) => m.toast);

// One translated toast for network failures; Retry re-sends failed mutations and reloads failed screens.
export const NetworkRetry = () => {
  const { t } = useI18n();
  const failed = useRef([]);
  useEffect(() => {
    const onFail = async (e) => {
      const { cfg } = e.detail;
      if ((cfg.method || "get") !== "get" && !failed.current.includes(cfg)) failed.current.push(cfg);
      (await toastLib()).error(t("net.failed"), {
        id: "am-network", duration: 12000, description: t("net.hint"),
        action: { label: t("net.retry"), onClick: retry },
      });
    };
    const retry = async () => {
      const list = failed.current.splice(0);
      const results = await Promise.allSettled(list.map((cfg) => http({ ...cfg, _retried: false })));
      window.dispatchEvent(new Event("am:retry"));
      if (list.length && results.every((r) => r.status === "fulfilled")) (await toastLib()).success(t("net.retried"), { id: "am-network" });
    };
    window.addEventListener("am:network-error", onFail);
    return () => window.removeEventListener("am:network-error", onFail);
  }, [t]);
  return null;
};
